import router from "@/router";
import store from "@/store";
import { ICabinet, ICard } from "@/struct/IHomePage/ICabinetBalance";
import UtilStorage from "@/util/Common/UtilStorage";
import { Capacitor } from "@capacitor/core";

export default class UtilError {
  public static validateError(
    statusCode: number,
    url: string,
    response_data: any,
  ): void {
    const showError = (
      error_message: string,
      replace_message = false,
      type: "error" | "warning" = "error",
    ) => {
      let message;
      if (!replace_message) {
        message = `<div>${error_message}</div> <div>Код ошибки: ${statusCode}</div> <div>Адрес запроса: ${url}</div><div>Отправьте скриншот данной ошибки Администратору!</div>`;
        (window as any).ErrorModal.Show(message, type);
        return;
      }
      message = `<div>${error_message}</div>`;
      (window as any).ErrorModal.Show(message, type);
    };

    if (response_data.detail === "APPLICATION_NOT_FOUND_ERROR") {
      return;
    }

    if (statusCode === 401) {
      UtilStorage.removeItem("token");
      router.replace("/");
      return;
    }

    if (statusCode === 403) {
      const error_message =
        "Проблема прав доступа к этому функционалу. Обратитесь к Администратору";

      return showError(error_message, true);
    }

    if (statusCode === 429) {
      const error_message =
        "Вы выполняете действие слишком часто, подождите пожалуйста";

      return showError(error_message, true);
    }

    if (statusCode === 422) {
      let errorMessage = "Ошибка: ";
      response_data.detail.forEach(
        (detail: { msg: string; loc: any[]; ctx: any }) => {
          detail.ctx.min_length
            ? (errorMessage += `Название карты должно содержать минимум ${detail.ctx.min_length} символа`)
            : (errorMessage += `${detail.msg} (${detail.loc.join(".")})`);
        },
      );

      return showError(errorMessage);
    }

    if (statusCode === 409) {
      if (response_data && response_data.detail && response_data.detail.id) {
        const error_message =
          "Неизвестная ошибка на сервере: \n Номер ошибки: " +
          response_data?.detail?.id;
        return showError(error_message);
      }

      return showError("Неожиданная ошибка на сервере");
    }

    if (statusCode === 500) {
      return showError("Неожиданная ошибка на сервере");
    }
    if (statusCode === 504) {
      return showError(
        "Неожиданная ошибка на сервере. Статус 504. Повторите действие чуть позже",
      );
    }

    if (statusCode === 502) {
      return showError(
        "Неожиданная ошибка на сервере. Статус 502. Повторите действие чуть позже",
      );
    }

    if (statusCode === 417) {
      return showError(
        `Ошибка:\n Код ошибки: ${statusCode}.\n
         ${response_data.detail}
        \n ${
          response_data.exception_id
            ? "ID Ошибки: " + response_data.exception_id
            : "Неизвестная ошибка"
        }\n Пожалуйста отправьте скриншот данной ошибки в поддержку.`,
      );
    }

    return showError(
      "Ошибка: " +
        "\n Ответ сервера: " +
        (response_data.message ? response_data.message : response_data.detail),
    );
  }

  public static async validateErrorMessage(message: string, phone?: string) {
    const showError = (error_message: string) => {
      (window as any).ErrorModal.Show(error_message, "error");
    };

    if (!phone)
      phone =
        ((await UtilStorage.getItem("phone")) as string) ||
        ((await UtilStorage.getItem("phoneRegisterYandex")) as string);

    if (
      message === "DRIVER_CARD_DELETE_ERROR" ||
      message === "driver_card_delete_error"
    ) {
      return showError(
        `Ошибка удаления карты. Пожалуйста отправьте эту ошибку в службу технической поддержки.`,
      );
    }

      if (
      message === "user_not_activate" ||
      message === "USER_NOT_ACTIVATE" ||
      message === "USER_NOT_ACTIVATION" ||
      message === "user_not_activation"
    ) {

      return showError(`${phone} не активирован. Обратитесь к партнеру.`);
    }

    if (
      message === "user_not_right_register" ||
      message === "USER_NOT_RIGHT_REGISTER"
    ) {
      return showError(
        `${phone} не числится в списке пользователей. Обратитесь к партнеру.`,
      );
    }
    if (message === "user_not_register" || message === "USER_NOT_REGISTER") {
      return showError(
        `${phone} не числится в списке пользователей. Обратитесь к партнеру.`,
      );
    }

    if (message === "USER_NOT_EXISTS" || message === "user_not_exists") {
      return showError(
        `Профиля с номером ${phone} нет в списке исполнителей.
        Убедитесь, что после создания профиля или смены номера телефона прошло более 40 минут.`,
      );
    }
    if (
      message === "user_already_exists" ||
      message === "USER_ALREADY_EXISTS"
    ) {
      return showError(`Пользователь с номером ${phone} уже зарегистрирован.`);
    }

    if (
      message === "no_necessary_yandex_permissions" ||
      message === "NO_NECESSARY_YANDEX_PERMISSIONS"
    ) {
      return showError(
        `Не получены необходимые данные для аутентификации от сервиса Yandex ID. Отзовите доступ к данным у сервиса Force2 в настройках безопасности YandexID и произведите авторизацию через YandexID повторно`,
      );
    }

    if (
      message === "yandex_username_dont_match" ||
      message === "YANDEX_USERNAME_DONT_MATCH"
    ) {
      return showError(
        `Номер телефона аккаунта Yandex не совпадает с номером телефона пользователя Force2`,
      );
    }
    if (
      message === "LOGIN_BAD_CREDENTIALS" ||
      message === "login_bad_credentials"
    ) {
      return showError(
        `Вы ввели неверный код-пароль для аккаунта ${phone}. Если Вы его забыли, обратитесь к партнеру для сброса.`,
      );
    }

    if (
      message === "DRIVER_SBP_ALREADY_EXIST" ||
      message === "DRIVER_CARD_ALREADY_EXIST" ||
      message === "driver_card_already_exist" ||
      message === "driver_sbp_already_exist"
    ) {
      return showError(
        `${phone} к данному номеру уже привязана такая карта для вывода.`,
      );
    }

    if (message === "OTP_ERROR" || message === "otp_error") {
      return showError(
        `К сожалению, сейчас мы не можем отправить код подтверждения. Пожалуйста, повторите попытку позже`,
      );
    }

    if (message === "DUPLICATE_CALL" || message === "duplicate_call") {
      return showError(
        `К сожалению, сейчас мы не можем отправить код подтверждения. Пожалуйста, повторите попытку позже`,
      );
    }

    // if (message === "no_partner_score" || message === "NO_PARTNER_SCORE") {
    //   return showError(
    //     `Попросите партнера подключить СБП для экономии на переводах.`,
    //   );
    // }

    if (message === "INVALID_DATA" || message === "invalid_data") {
      return showError(
        "Неверные параметры запроса. Обратитесь к администратору",
      );
    }
    if (message === "INVALID_DEVICE" || message === "invalid_device") {
      return showError(
        "Выполнен запрос с неверного устройства. Обратитесь к администратору",
      );
    }
    if (message === "INVALID_CODE" || message === "invalid_code") {
      return showError(
        "Неверный код подтверждения! попробуйте позвонить еще раз.",
      );
    }

    if (message === "error_check_system" || message === "ERROR_CHECK_SYSTEM") {
      return showError(`Ошибка проверки номера телефона в системе СБП`);
    }

    if (
      message === "phone_missing_the_bank" ||
      message === "PHONE_MISSING_THE_BANK"
    ) {
      return showError(
        `Номер телефона в системе банка не зарегистрирован, выберите другой банк`,
      );
    }

    if (message === "short_card_name" || message === "SHORT_CARD_NAME") {
      return showError("Название карты должно содержать минимум 3 символа");
    }

    if (
      message === "sbp_bank_dont_choose" ||
      message === "SBP_BANK_DONT_CHOOSE"
    ) {
      return showError(`Выберите банк из списка чтобы добавить СБП карту`);
    }

    if (
      message === "exceeded_the_payout_limit" ||
      message === "EXCEEDED_THE_PAYOUT_LIMIT"
    ) {
      return showError(
        "Вывод денег доступен один раз в 15 минут. Подождите пожалуйста",
      );
    }

    if (message === "payout_disabled" || message === "PAYOUT_DISABLED") {
      return showError("Выплаты отключены. Уточните график выплат у партнера");
    }

    if (message === "time_out" || message === "TIME_OUT") {
      return showError(
        "Проблема с интернет соединением. Проверьте ваше подключение к интернету и повторите попытку",
      );
    }

    if (
      message === "finished_trying_enter_code" ||
      message === "FINISHED_TRYING_ENTER_CODE"
    ) {
      return showError(
        "Превышено количество попыток ввода пароля. Снять блокировку может Ваш партнер",
      );
    }

    if (
      message === "limiting_input_attempts" ||
      message === "LIMITING_INPUT_ATTEMPTS"
    ) {
      return showError(
        "Превышено количество попыток ввода. Попробуйте позже или обратитесь к вашему партнеру",
      );
    }

    if (message === "duplicate_call" || message === "DUPLICATE_CALL") {
      return showError("Проблема отправки повторного звонка. Попробуйте позже");
    }

    if (
      message === "error_with_request_login" ||
      message === "ERROR_WITH_REQUEST_LOGIN"
    ) {
      if (Capacitor.getPlatform() != "web") {
        return showError(
          "Проблемы с логином. Попробуйте попытку еще раз или перейдите веб версию - https://pro.force2.ru. Номер телефона: " +
            phone,
        );
      } else {
        return showError(
          "Проблемы с логином. Попробуйте попытку еще раз или напишите в тех поддержку. Номер телефона: " +
            phone,
        );
      }
    }

    if (message === "incorrect_password" || message === "INCORRECT_PASSWORD") {
      return showError(
        `Вы ввели неверный код-пароль для аккаунта ${phone}. Если Вы его забыли, обратитесь к партнеру для сброса.`,
      );
    }

    if (message === "access_denied" || message === "ACCESS_DENIED") {
      return showError(
        "Этот номер используется для входа в кабинет партнера. Доступ в приложение для водителя запрещен.",
      );
    }

    if (message === "repeat_cabinets" || message === "REPEAT_CABINETS") {
      return showError(
        "Не удалось проверить корректность суммы. пожалуйста, обновите страницу.",
      );
    }

    if (message === "otp_error" || message === "OTP_ERROR") {
      return showError(
        "Проблема с отправкой звонка. Вы можете авторизоваться через Telegram без получения звонка если у Вас этот номер телефона: " +
          phone,
      );
    }

    if (
      message === "ERROR_MAX_PAYMENT_CALCULATION" ||
      message === "error_max_payment_calculation"
    ) {
      return showError(
        "Не смогли рассчитать сумму выплаты. Пожалуйста, обновите страницу и повторите запрос",
      );
    }

    if (message === "MAX_AMOUNT_EXCEEDS" || message === "max_amount_exceeds") {
      return showError(
        "Превышена максимальная сумма выплаты. Пожалуйста, уменьшите сумму или обратитесь к партнеру",
      );
    }

    if (
      message === "BALANCE_IS_BEING_CHANGED" ||
      message === "balance_is_being_changed"
    ) {
      return showError(
        "Производится изменение баланса предыдущей транзакцией. Повторите выплату позже",
      );
    }

    if (message === "NO_CARD_DRIVER" || message === "no_card_driver") {
      return showError(
        "Пожалуйста, добавьте карту или номер телефона для переводов по СБП",
      );
    }

    if (
      message === "CARD_DRIVER_NOT_APPROVED" ||
      message === "card_driver_not_approved"
    ) {
      return showError(
        "Карта не подтверждена. Пожалуйста, обратитесь к партнеру",
      );
    }

    // if (message === "NO_PARTNER_SCORE" || message === "no_partner_score") {
    //   return showError(
    //     "Партнер отключил выплаты по номеру карты. Пожалуйста, воспользуйтесь СБП",
    //   );
    // }

    // if (
    //   message === "NO_PARTNER_SCORE_BY_SBP" ||
    //   message === "no_partner_score_by_sbp"
    // ) {
    //   return showError(
    //     "Партнер отключил СБП. Воспользуйтесь выплатой по номеру карты",
    //   );
    // }

    if (message === "HAVE_BLOCKING_DOCS" || message === "have_blocking_docs") {
      return showError("Водитель имеет блокировку за несданные документы");
    }

    if (
      message === "ERROR_GET_DRIVER_BALANCE" ||
      message === "error_get_driver_balance"
    ) {
      return showError("Ошибка при получении баланса водителя");
    }

    if (
      message === "REQUEST_ACCEPTED_PROCESSING" ||
      message === "request_accepted_processing"
    ) {
      return showError(
        "Выплата обрабатывается. Пожалуйста, ожидайте изменение статуса",
      );
    }

    if (
      message === "ERROR_MAX_PAYMENT_CALCULATION" ||
      message === "error_max_payment_calculation"
    ) {
      return showError(
        "Не смогли рассчитать сумму выплаты. Пожалуйста, обновите страницу и повторите запрос",
      );
    }

    if (message === "MAX_AMOUNT_EXCEEDS" || message === "max_amount_exceeds") {
      return showError(
        "Превышена максимальная сумма выплаты. Пожалуйста, уменьшите сумму или обратитесь к партнеру",
      );
    }

    if (
      message === "BALANCE_IS_BEING_CHANGED" ||
      message === "balance_is_being_changed"
    ) {
      return showError(
        "Производится изменение баланса предыдущей транзакцией. Повторите выплату позже",
      );
    }

    if (message === "NO_CARD_DRIVER" || message === "no_card_driver") {
      return showError(
        "Пожалуйста, добавьте карту или номер телефона для переводов по СБП",
      );
    }

    if (
      message === "CARD_DRIVER_NOT_APPROVED" ||
      message === "card_driver_not_approved"
    ) {
      return showError(
        "Карта не подтверждена. Пожалуйста, обратитесь к партнеру",
      );
    }

    if (message === "NO_PARTNER_SCORE" || message === "no_partner_score") {
      return showError(
        "Партнер отключил выплаты по номеру карты. Пожалуйста, воспользуйтесь СБП",
      );
    }

    if (
      message === "NO_PARTNER_SCORE_BY_SBP" ||
      message === "no_partner_score_by_sbp"
    ) {
      return showError(
        "Партнер отключил СБП. Воспользуйтесь выплатой по номеру карты",
      );
    }

    if (message === "HAVE_BLOCKING_DOCS" || message === "have_blocking_docs") {
      return showError("Водитель имеет блокировку за несданные документы");
    }

    if (
      message === "ERROR_GET_DRIVER_BALANCE" ||
      message === "error_get_driver_balance"
    ) {
      return showError("Ошибка при получении баланса водителя");
    }

    if (
      message === "REQUEST_ACCEPTED_PROCESSING" ||
      message === "request_accepted_processing"
    ) {
      return showError(
        "Выплата обрабатывается. Пожалуйста, ожидайте изменение статуса",
      );
    }

    if (
      message === "OPERATOR_ALREADY_EXISTS" ||
      message === "operator_already_exists"
    ) {
      return showError(
        "Оператор с этим номером телефона уже зарегистрирован в системе",
      );
    }

    if (message === "OPERATOR_BLOCKED" || message === "operator_blocked") {
      return showError("Оператор заблокирован");
    }

    if (
      message === "OPERATOR_CREATE_ERROR" ||
      message === "operator_create_error"
    ) {
      return showError("Ошибка создания оператора");
    }

    if (
      message === "OPERATOR_UPDATE_ERROR" ||
      message === "operator_update_error"
    ) {
      return showError("Ошибка обновления оператора");
    }

    if (
      message === "OPERATOR_UPDATE_IS_UNAVAILABLE" ||
      message === "operator_update_is_unavailable"
    ) {
      return showError(
        "Оператор является водителем. Пожалуйста измените данные в кабинете Яндекс",
      );
    }

    if (message === "MANAGER_NOT_EXISTS" || message === "manager_not_exists") {
      return showError("Партнер в системе не найден");
    }

    if (
      message === "REQUISITE_NOT_EXISTS" ||
      message === "requisite_not_exists"
    ) {
      return showError("Указанный ИНН в системе не существует");
    }

    if (
      message === "INVALID_DEVICE_HASH" ||
      message === "invalid_device_hash"
    ) {
      return showError(
        "Ошибка идентификации устройства. Пожалуйста, воспользуйтесь PWA или обновите мобильное приложение",
      );
    }

    if (
      message === "REGISTRATION_FORM_INN_ALREADY_EXISTS" ||
      message === "registration_form_inn_already_exists"
    ) {
      return showError("Партнер с таким ИНН уже зарегистрирован");
    }

    if (
      message === "REGISTRATION_FORM_ALREADY_EXISTS" ||
      message === "registration_form_already_exists"
    ) {
      return showError(
        "Партнер с таким ИНН уже зарегистрирован. Если Вы ранее подавали заявку за регистрацию, уточните ее статус у администрации системы",
      );
    }

    if (
      message === "REGISTRATION_REQUEST_PROCESSING" ||
      message === "registration_request_processing"
    ) {
      return showError(
        "Форма регистрации отправлена администрации. Пожалуйста, ожидайте подтверждения регистрации",
      );
    }

    if (
      message === "REGISTRATION_FORM_UPDATE_ERROR" ||
      message === "registration_form_update_error"
    ) {
      return showError("Ошибка обновления данных на стороне сервера");
    }

    if (
      message === "AUTH_GROUP_ALREADY_EXISTS" ||
      message === "auth_group_already_exists"
    ) {
      return showError("Группа пользователей с таким именем уже существует");
    }

    if (
      message === "AUTH_GROUP_UPDATE_ERROR" ||
      message === "auth_group_update_error"
    ) {
      return showError(
        "Ошибка обновления данных группы. Пожалуйста попробуйте запрос позже",
      );
    }

    if (
      message === "AUTH_GROUP_CREATE_ERROR" ||
      message === "auth_group_create_error"
    ) {
      return showError("Ошибка создания группы прав доступа");
    }

    if (
      message === "AUTH_GROUP_DELETE_ERROR" ||
      message === "auth_group_delete_error"
    ) {
      return showError("Ошибка удаление группы прав доступа");
    }

    if (
      message === "AUTH_GROUP_NOT_EXISTS" ||
      message === "auth_group_not_exists"
    ) {
      return showError("Неверный идентификатор группы доступа");
    }

    if (
      message === "AUTH_GROUP_IS_USERS" ||
      message === "auth_group_is_users"
    ) {
      return showError(
        "За группой прав доступа закреплены пользователи. Удаление невозможно",
      );
    }

    if (
      message === "PERMISSIONS_NOT_EXISTS" ||
      message === "permissions_not_exists"
    ) {
      return showError("Переданы неверные идентификаторы прав доступа");
    }

    if (
      message === "YANDEX_AUTHORIZATION_ERROR" ||
      message === "yandex_authorization_error"
    ) {
      return showError("Ошибка авторизации YandexID");
    }

    if (message === "YANDEX_AUTH_FAILED" || message === "yandex_auth_failed") {
      return showError("Токен Яндекса не получен");
    }

    if (message === "network_error") {
      return showError(
        "Проверьте интернет. Отключите VPN. Также завершите текущий вызов (по мобильной сети), если он ещё идёт.",
      );
    }

    if (message === "storage_error") {
      return showError(
        "Ошибка доступа к данным. Перезапустите приложение или переустановите его.",
      );
    }

    if (message === "platform_error") {
      return showError(
        "Ошибка платформы. Перезапустите приложение. Если не поможет — переустановите.",
      );
    }

    if (message === "fingerprint_error") {
      return showError(
        "Не удалось определить слепок устройства. Разрешите доступ к данным устройства в настройках.",
      );
    }

    if (message === "internal_error") {
      return showError(
        "Что-то пошло не так. Перезапустите приложение. Если ошибка повторится — сообщите в поддержку.",
      );
    }

    showError(
      `Системное уведомление ${message}\n Технические работы\n Вышлите в поддержку скриншот экран`,
    );
  }

  public static async validateWithdrawError(
    userActiveBalanceWithdraw: ICabinet | null,
    withdrawBalance: string,
    cards: ICard[],
    waSupport: string,
  ): Promise<string | boolean> {
    if (!userActiveBalanceWithdraw) {
      return "Ошибка, код: 'withdraw_cabinet_null'. Отправьте его Администратору!";
    }
    if (!cards?.length) {
      return "У вас нет карт для вывода, добавьте карту и попробуйте еще раз!";
    }

    const currentCard = cards.find((item) => item.is_main);
    if (currentCard && !currentCard.is_approved) {
      const user = store.state.userData;

      const userFullName = user?.full_name.split("null").join("");

      const waSupportNumber = waSupport;
      const textMessage = `Прошу подтвердить карту "${currentCard.name}" ${currentCard.number}. Водител ${userFullName}, номер телефона: ${user?.phone_number}`;

      const href = encodeURI(
        `https://api.whatsapp.com/send?phone=${waSupportNumber}&text=${textMessage}`,
      );
      return `Ваша карта не подтверждена. <br> Отправьте скриншот экрана в "парк" <br> (партнеру). <br>  WhatsApp: ${waSupportNumber}`;
    }

    if (!userActiveBalanceWithdraw.is_payment) {
      const user = store.state.userData;

      const userFullName = user?.full_name.split("null").join("");
      const waSupportNumber = waSupport;
      const textMessage = `Водитель ${userFullName} с номером ${user?.phone_number} нажал в приложении кнопку "У меня отключены выплаты". Кабинет ${userActiveBalanceWithdraw.name}`;

      const href = encodeURI(
        `https://api.whatsapp.com/send?phone=${waSupportNumber}&text=${textMessage}`,
      );

      return `Выплаты с кабинета ${userActiveBalanceWithdraw.name} выключены.<br> Отправьте скриншот экрана в "парк" <br> (партнеру). <br>  WhatsApp: ${waSupportNumber}`;
    }

    const balanceWithdraw = Number(withdrawBalance);
    const { amount, min_amount, irreducible_balance } =
      userActiveBalanceWithdraw;

    if (isNaN(balanceWithdraw) || balanceWithdraw < 0) {
      return "Сумма к выплате должна быть числом и больше нуля";
    }

    if (balanceWithdraw === 0) {
      return "Сумма к выплате должна быть больше нуля";
    }

    if (balanceWithdraw > amount) {
      return `Нельзя вывести больше ${amount} (вы выводите: ${balanceWithdraw}), неснижаемый остаток ${irreducible_balance}. Укажите сумму меньше.`;
    }

    if (balanceWithdraw < min_amount) {
      return `Минимальная сумма к выводу: ${min_amount}`;
    }

    if (balanceWithdraw > 100000) {
      return `Максимальная сумма к выводу: 100 000 руб.`;
    }

    return true;
  }

  public static async validateErrorMessageOnBackend(
    detail: string,
    message: string,
  ) {
    const showError = (error_message: string, type = "warning") => {
      (window as any).ErrorModal.Show(error_message, type);
    };

    if (!message) {
      return showError(`Не известная ошибка, код ошибки: ${detail}`, "error");
    }

    return showError(message);
  }
}
